import { useLazyQuery } from '@apollo/client';
import { useState } from 'react';
import PropTypes from 'prop-types';

import { REMOVE_UNDO_REDO_VERSION } from '../../apis/version';
import { useAuth } from '../../context/AuthContext';
import Button from '../atoms/button';
import Modal from '../organisms/modal';

const propTypes = {
  component: PropTypes.node.isRequired,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  handleDialog: PropTypes.func.isRequired,
  onLogoutSuccess: PropTypes.func,
};
const defaultProps = {};

const LogoutDialog = ({ component, openDialog, setOpenDialog, handleDialog, onLogoutSuccess }) => {
  // init
  const { logOut } = useAuth();

  // states
  const [isLoading, setIsLoading] = useState(false);

  // mutations/queries
  const [removeUndoRedoVersions] = useLazyQuery(REMOVE_UNDO_REDO_VERSION, { fetchPolicy: 'network-only' });

  const onSignoutSuccess = async () => {
    try {
      setIsLoading(true);
      await logOut();
      await removeUndoRedoVersions();
      localStorage.removeItem('Width');
      localStorage.removeItem('WrapText');
      setOpenDialog(false);
      if (onLogoutSuccess) onLogoutSuccess();
    } catch (error) {
      if (onLogoutSuccess) onLogoutSuccess();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {component}
      <Modal
        title="Logout User"
        body="Are you sure you want to logout?"
        secondaryButton={<Button isLoading={isLoading} disabled={isLoading} danger onClick={onSignoutSuccess}>Logout Now</Button>}
        primaryButton={<Button disabled={isLoading} primary outlined onClick={handleDialog}>Stay here</Button>}
        isOpen={openDialog}
        actionAlignment="right"
        setIsOpen={handleDialog}
      />
    </>
  );
};

LogoutDialog.propTypes = propTypes;
LogoutDialog.defaultProps = defaultProps;
export default LogoutDialog;
